import React from "react";
import "../../../Assets/Css/EmployeeLeave.scss";
import Table from "../../../Components/Table";
import { useLocation, useNavigate } from "react-router-dom";
import "react-datepicker/dist/react-datepicker.css";
import { useEffect } from "react";
import { customStyle } from '../../../Components/Style'
import { useState } from "react";
import { connect } from "react-redux";
import Select from 'react-select'
import { getAuthHeader } from "../../../Lib/utils";
import { toast } from "react-toastify";
import { Spinner } from "react-bootstrap";
import { api } from "../../../Lib/constants";
import CustomCalendar from '../../../Components/CustomCalendar';
import Drag_Drop from "../../../Assets/Images/Employee/Drag_Drop"
import Summery from "../../../Assets/Images/Employee/Summery"
import { getLeaves, updateLeave, addMonthlyLeave } from "../../../Services/Leave/action";
import qs from "query-string";
import moment from "moment";
import { deleteRecord } from "../../../Services/Delete/action";
import ModulesList from "../../../Assets/ModulesLiist";
import FeaturesList from "../../../Assets/FeaturesList";
import RoleWiseFeatureWrapper, { checkFeatureAccess } from "../../../Lib/RoleWiseFeatureWrapper";
import { FaList } from "react-icons/fa";
import { BiCalendarStar } from "react-icons/bi";
import Skeleton from "react-loading-skeleton";
import EventsListsList from "../../../Assets/Images/Attendance/EventsListsList";
import EventsListsCalendar from "../../../Assets/Images/Attendance/EventsListsCalendar";

const calculateRemainingDaysInCycle = (unpaidLeavesTaken = 0) => {
    const currentDate = moment();
    const currentYear = currentDate.year();


    let cycleStartDate, cycleEndDate;


    if (currentDate.isBefore(moment(`${currentYear}-07-01`))) {
        cycleStartDate = moment(`${currentYear - 1}-07-01`);
        cycleEndDate = moment(`${currentYear}-07-01`);
    } else {

        cycleStartDate = moment(`${currentYear}-07-01`);
        cycleEndDate = moment(`${currentYear + 1}-07-01`);
    }


    const remainingDaysInCalendar = cycleEndDate.diff(currentDate, 'days');


    const availableUnpaidDays = Math.max(0, remainingDaysInCalendar - unpaidLeavesTaken);

    return {
        remainingDays: availableUnpaidDays,
        totalRemainingCalendarDays: remainingDaysInCalendar,
        unpaidLeavesTaken: unpaidLeavesTaken,
        cycleStartDate: cycleStartDate.format('DD-MM-YYYY'),
        cycleEndDate: cycleEndDate.format('DD-MM-YYYY'),
        totalCycleDays: cycleEndDate.diff(cycleStartDate, 'days')
    };
};

const Project = (props) => {
    const [checked, setChecked] = useState(false);
    const [params, setParams] = useState({});
    const [totalSelectedIds, setTotalSelectedIds] = useState([]);
    const [exportLoading, setExportrLoading] = useState(false);
    const [deleteLoading, setDeleteLoading] = useState(false);
    const [inData, setInData] = useState([]);
    const [activeButton, setActiveButton] = useState("");
    const [filteredData, setFilteredData] = useState([]);
    const [totalEarned, setTotalEarned] = useState(0);
    const [totalUnpaid, setTotalUnpaid] = useState(0);
    const [totalCasualLeavesAvailable, setTotalCasualLeavesAvailable] = useState(0);
    const [totalCasualTakenFromBackend, setTotalCasualTakenFromBackend] = useState(0);
    const [totalUnpaidTakenInCycle, setTotalUnpaidTakenInCycle] = useState(0);
    const [leaveCycleInfo, setLeaveCycleInfo] = useState({
        remainingDays: 0,
        totalRemainingCalendarDays: 0,
        unpaidLeavesTaken: 0,
        cycleStartDate: '',
        cycleEndDate: '',
        totalCycleDays: 0
    });
    const currentUser = props?.users?.find(
        (user) => user?.id === props?.user?.id
    );

    const canView = checkFeatureAccess({
        modules: props?.modules,
        features: props?.features,
        user: props?.user,
        ModuleName: ModulesList.Leaves,
        Featur_Name: FeaturesList.View,
    });

    const canDelete = checkFeatureAccess({
        modules: props?.modules,
        features: props?.features,
        user: props?.user,
        ModuleName: ModulesList.Leaves,
        Featur_Name: FeaturesList.Delete,
    });
    const canEdit = checkFeatureAccess({
        modules: props?.modules,
        features: props?.features,
        user: props?.user,
        ModuleName: ModulesList.Leaves,
        Featur_Name: FeaturesList.Update,
    });

    const canApprove = checkFeatureAccess({
        modules: props?.modules,
        features: props?.features,
        user: props?.user,
        ModuleName: ModulesList.Leaves,
        Featur_Name: FeaturesList.Approve,
    });

    const canReject = checkFeatureAccess({
        modules: props?.modules,
        features: props?.features,
        user: props?.user,
        ModuleName: ModulesList.Leaves,
        Featur_Name: FeaturesList.Reject,
    });

    const location = useLocation();
    const navigate = useNavigate();
    const header = [
        // { field: "checkbox" },
        { field: "Employee" },
        { field: "Start Date" },
        { field: "End Date" },
        { field: "Duration" },
        { field: "Leave Status" },
        { field: "Leave Type" },
        { field: "Action" },
    ];

    const LeaveType = [
        { value: "Casual", label: "Casual" },
        { value: "Earned", label: "Earned" },
        { value: "Unpaid", label: "Unpaid" },
    ];

    const LeaveStatus = [
        { value: "Pending", label: "Pending" },
        { value: "Approved", label: "Approved" },
        { value: "Rejected", label: "Rejected" },
    ];

    let footer = true;
    let count = inData?.length;

    useEffect(() => {
        fetchData();
    }, [location.search]);

    const fetchData = async () => {
        try {
            setParams(qs.parse(location.search, { ignoreQueryPrefix: true }));
            await props?.getLeaves();
        } catch (error) {
            console.error("Error fetching leaves:", error);
        }
    };

    const showToastMessage = (error) => {
        toast.error(error, {
            position: toast.POSITION.TOP_RIGHT,
        });
    };

    useEffect(() => {
        let casual = 0;
        let earned = 0;
        let unpaid = 0;
        let totalCasualTakenFromBackend = 0;
        const filtered = props?.user?.role?.name === 'employee'
            ? props?.leave?.filter(l => l?.employee_id == props?.user?.id)
            : props?.leave;
        const groupedDatesMap = {};
        const userCasualTotals = {};
        filtered?.forEach(item => {
            const createdAt = item?.createdAt;

            if (!groupedDatesMap[createdAt]) {
                groupedDatesMap[createdAt] = [];
            }

            groupedDatesMap[createdAt].push(item);

            if (item?.casual > 0) casual += parseFloat(item?.casual, 10);
            if (item?.unpaid) unpaid += parseFloat(item?.unpaid, 10);
            const userId = item?.employee_id;
            if (!userCasualTotals[userId] && item?.totalCasualTaken) {
                userCasualTotals[userId] = item.totalCasualTaken;
            }
            setTotalCasualLeavesAvailable(item?.user?.casual_leave);
        });

        const mapped = [];
        Object.values(groupedDatesMap).forEach(group => {
            if (group.length > 1) {
                const firstItem = group[0];
                const allIds = group.map(item => item.id);
                mapped.push({
                    checkbox: {
                        value: allIds,
                        type: "checkbox",
                    },
                    Employee: {
                        value: firstItem?.user?.name,
                        value2: firstItem?.user?.designation?.name,
                        src: firstItem?.user?.profile_pic?.data || "",
                        type: "client",
                        isClickable: true,
                        clickPath: `/employees/view/profile/${firstItem?.user?.id}`,
                        employeeId: firstItem?.user?.id,
                        employeeData: firstItem?.user,
                        totalCasualTaken: userCasualTotals[firstItem?.employee_id] || 0

                    },
                    "Start Date": {
                        value: moment(firstItem?.start_date?.split(" ")?.[0])?.format("DD-MM-YYYY"),
                        type: "date"
                    },
                    "End Date": {
                        value: moment(group[group?.length - 1]?.end_date?.split(" ")?.[0])?.format("DD-MM-YYYY"),
                        type: "date"
                    },
                    Duration: {
                        value: "Multiple",
                        type: "text"
                    },
                    "Leave Status": {
                        value: firstItem?.status,
                        type: "leaveStatus"
                    },
                    "Leave Type": {
                        value: group.every(t => t?.casual > 0) ? "Casual" :
                            group.every(t => t?.unpaid > 0) ? "Unpaid" :
                                "Casual/Unpaid",
                        value2: "",
                        type: "leaveType"
                    },
                    Action: {
                        value: "/leave/empleave/edit",
                        value2: "/leave/empleave/view/multiple",
                        value3: group.map(i => i?.id),
                        showIsApprove: canApprove && firstItem?.status != "Approved",
                        showIsEdit: canEdit && firstItem?.status == "Pending",
                        showIsDelete: canDelete && firstItem?.status == "Pending",
                        showIsReject: canReject && firstItem?.status != "Rejected",
                        value4: "Approve",
                        value5: "Reject",
                        type: "action",
                    },
                    allData: {
                        ...group,
                    }
                });
            } else {
                const item = group[0];

                mapped.push({
                    checkbox: {
                        value: item?.id,
                        type: "checkbox",
                    },
                    Employee: {
                        value: item?.user?.name,
                        value2: item?.user?.designation?.name,
                        src: item?.user?.profile_pic?.data || "",
                        type: "client",
                        isClickable: true,
                        clickPath: `/employees/view/profile/${item?.user?.id}`,
                        employeeId: item?.user?.id,
                        employeeData: item?.user,
                        totalCasualTaken: userCasualTotals[item?.employee_id] || 0
                    },
                    "Start Date": {
                        value: moment(item?.start_date?.split(" ")?.[0])?.format("DD-MM-YYYY"),
                        type: "date"
                    },
                    "End Date": {
                        value: moment(item?.end_date?.split(" ")?.[0])?.format("DD-MM-YYYY"),
                        type: "date"
                    },
                    Duration: {
                        value: (item?.firstHalf && item?.secondHalf) ? 'Single' : "Half Day",
                        type: "text"
                    },
                    "Leave Status": {
                        value: item?.status,
                        type: "leaveStatus"
                    },
                    "Leave Type": {
                        value: (item?.casual > 0 && item?.unpaid > 0) ? "Casual/Unpaid" : item?.unpaid > 0 ? "Unpaid" : "Casual",
                        value2: (item?.firstHalf && item?.secondHalf) ? "" : item?.firstHalf ? 'First Half' : 'Second Half',
                        type: "leaveType"
                    },
                    Action: {
                        value: "/leave/empleave/edit",
                        value2: `/leave/empleave/view/${item?.id}`,
                        value3: item?.id,
                        showIsEdit: canEdit && item?.status == "Pending",
                        showIsDelete: canDelete && item?.status == "Pending",
                        showIsApprove: canApprove && item?.status != "Approved",
                        showIsReject: canReject && item?.status != "Rejected",
                        value4: "Approve",
                        value5: "Reject",
                        type: "action",
                    },
                    allData: {
                        ...item
                    }
                });
            }
        });

        setTotalEarned(earned);
        setTotalUnpaid(unpaid);
        setInData(mapped);
        const currentUserCasualTaken = userCasualTotals[props?.user?.id] || 0;
        setTotalCasualTakenFromBackend(currentUserCasualTaken);

    }, [props, location?.pathname]);

    useEffect(() => {
        if (location.pathname === "/leave/empleave") {
            setActiveButton(location.pathname.slice(7))
        } else if (location.pathname === "/leave/empleave/empcalendar") {
            setActiveButton(location.pathname.slice(16))
        }
    }, []);

    const handleClickBtn = (buttonId, route) => {
        setActiveButton(buttonId);
        navigate(route);
    };

    const handleChange = (event) => {
        const { type, checked, id, ids } = event;

        if (type === "select-all") {
            setTotalSelectedIds(checked ? [...ids] : []);
        } else if (type === "select-one") {
            if (checked) {
                setTotalSelectedIds(prev => [...prev, id]);
            } else {
                setTotalSelectedIds(prev => prev.filter(selectedId => selectedId !== id));
            }
        }
    };

    const handleClick = async (totalSelectedIds, type) => {
        let ids = totalSelectedIds.map((id) => parseFloat(id));

        try {
            if (type === "delete") {
                setDeleteLoading(true);
                await props.deletePurchaseInvoices(ids);
                setChecked(false);
                setTotalSelectedIds([]);
            } else if (type === "export") {
                setExportrLoading(true);
                await handlePdfDownload(ids);
                toast.success("Exported Successfully");
            }
        } catch (error) {
            console.error(error);
        } finally {
            await fetchData();
            setDeleteLoading(false);
        }
    };

    const handlePdfDownload = async (ids) => {
        try {
            for (let id of ids) {
                let result = await api(
                    `invoices/generate/pdf`,
                    "post",
                    { ids: [id] },
                    getAuthHeader(),
                    { responseType: "blob" }
                );
                const url = window.URL.createObjectURL(result.data);
                downloadURI(url, `${id}.pdf`);
            }
            setExportrLoading(false);
        } catch (error) {
            let errorMessage = error?.message;
            showToastMessage(errorMessage);
            setExportrLoading(false);
        }
    };

    function downloadURI(uri, name) {
        var link = document.createElement("a");
        link.download = name;
        link.href = uri;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    }

    useEffect(() => {
        if (totalSelectedIds.length > 0) {
            setChecked(true);
        } else {
            setChecked(false);
        }
    }, [totalSelectedIds]);

    const handleAddClick = () => {
        navigate('/leave/empleave/add');
    }
    const handleMonthlyLeaveClick = async () => {
        try {
            const currentDate = new Date();
            const currentMonth = currentDate.getMonth() + 1;
            const currentYear = currentDate.getFullYear();
            const monthlyLeaveData = {
                month: currentMonth,
                year: currentYear,
                employee_id: props?.user?.id
            };

            await props?.addMonthlyLeave(monthlyLeaveData, navigate);
        } catch (error) {
            console.error("Error adding monthly leave:", error);
        }
    }

    const initialState = {
        leavetype: null,
        leavestatus: { value: 'Pending', label: 'Pending' }
    }

    const [clientData, setClientData] = useState(initialState);
    const [dateStatus, setDateStatus] = useState(false);
    const [filteredStartDate, setFilteredStartDate] = useState(null);
    const [filteredEndDate, setFilteredEndDate] = useState(null);

    const applyFilters = ({ startDate, endDate, type, status }) => {
        setFilteredStartDate(filteredStartDate || startDate);
        setFilteredEndDate(filteredEndDate || endDate);
        const filtered = inData?.filter((leave) => {
            let matchesStatus = true;
            let matchesDate = true;
            let matchesType = true;
            if ((filteredStartDate || startDate) && (filteredEndDate || endDate)) {
                setDateStatus(true);

                 const itemStartDate = moment(leave?.["Start Date"]?.value, "DD-MM-YYYY").startOf('day');
            const itemEndDate = moment(leave?.["End Date"]?.value, "DD-MM-YYYY").startOf('day');

                const filterStart = moment(filteredStartDate || startDate).startOf('day');
                const filterEnd = moment(filteredEndDate || endDate).endOf('day');

                matchesDate = itemStartDate.isSameOrBefore(filterEnd) && itemEndDate.isSameOrAfter(filterStart);
            }
            if (status) {
                matchesStatus = leave?.["Leave Status"]?.value?.toLowerCase() == status?.value?.toLowerCase();
            }

            if (type) {
                matchesType = leave?.["Leave Type"]?.value?.toLowerCase() == type?.value?.toLowerCase();
            }
            return matchesStatus && matchesDate && matchesType;
        });
        setFilteredData(filtered);
    };

    useEffect(() => {
        if (inData?.length > 0 && initialState?.leavestatus) {
            applyFilters({ status: initialState?.leavestatus });
        }
    }, [inData]);

    const handleClear = () => {
        setClientData({
            leavetype: null,
            leavestatus: null
        });
        setDateStatus(false);
        setFilteredData([]);
        setFilteredStartDate(null);
        setFilteredEndDate(null);
    }

    const shouldShowClearButton = () => {
        const hasDateFilter = dateStatus;
        const hasType = clientData?.leavetype;
        const hasStatus = clientData?.leavestatus;
        return hasDateFilter || hasType || hasStatus;
    };

    useEffect(() => {
        const updateCycleInfo = () => {

            const currentUserUnpaidTaken = parseFloat(props?.user?.unpaid_leave || 0);
            const cycleInfo = calculateRemainingDaysInCycle(currentUserUnpaidTaken);
            setLeaveCycleInfo(cycleInfo);
        };

        updateCycleInfo();


        const now = moment();
        const tomorrow = moment().add(1, 'day').startOf('day');
        const msUntilMidnight = tomorrow.diff(now);

        const timeoutId = setTimeout(() => {
            updateCycleInfo();
            const intervalId = setInterval(updateCycleInfo, 24 * 60 * 60 * 1000);
            return () => clearInterval(intervalId);
        }, msUntilMidnight);

        return () => clearTimeout(timeoutId);
    }, [props?.user?.unpaid_leave, props?.user?.id]);


    useEffect(() => {

        if (props?.user?.id) {
            const currentUserUnpaidTaken = parseFloat(props?.user?.unpaid_leave || 0);
            const cycleInfo = calculateRemainingDaysInCycle(currentUserUnpaidTaken);
            setLeaveCycleInfo(cycleInfo);
        }
    }, [props?.leave, props?.user?.unpaid_leave]);

    return (
        <div className="empLeave-main">
            <div className="page-title">
                {
                    props.loading ? (
                        <Skeleton className='rounded-2' width={200} height={40} />
                    ) : (
                        <h4>Leaves</h4>
                    )
                }
                <div>
                    {
                        props.loading ? (<Skeleton className='badge rounded-pill' width={100} height={40} />) : (
                            (props?.user?.role?.name === 'admin' || 
                             props?.user?.role?.name === 'hr_senior' || 
                             props?.user?.role?.name === 'hr' || 
                             props?.user?.role?.name === 'hr_junior') && (
                                    <button
                                        className="custom-empleave-btn me-3"
                                        disabled={props.loading}
                                        onClick={handleMonthlyLeaveClick}
                                    >
                                        Credit Leaves
                                    </button>
                            )
                        )
                    }
                    {
                        props.loading ? (<Skeleton className='badge rounded-pill' width={100} height={40} />) : (
                            <RoleWiseFeatureWrapper
                                modules={props?.modules}
                                features={props?.features}
                                user={props?.user}
                                ModuleName={ModulesList.Leaves}
                                Featur_Name={FeaturesList.Create}>
                                <button className="custom-empleave-btn me-3" disabled={props.loading} onClick={handleAddClick}>
                                    Add Leave
                                </button>
                            </RoleWiseFeatureWrapper>
                        )
                    }
                </div>
            </div>
            <div className="main-division">
                <div className="row">
                    <div className="col-lg-12 mb-3">
                        <div className="right-parts">
                            <div className="sub-row">
                                <div className="leave-detail-part">
                                    {
                                        props.loading ? (
                                            <Skeleton className='rounded-2' width={200} height={40} />
                                        ) : (
                                            <h6 className="leave-detail-heading">Leave Quota</h6>
                                        )
                                    }
                                </div>
                                <div className="row leave-info">
                                    <div className="col-lg-6 col-sm-12">
                                        {
                                            props.loading ? (
                                                <Skeleton className='rounded-2' width="100%" height={100} />
                                            ) : (
                                                <div className="casual-detail-info">
                                                    <span className="casual-heading">Casual Leave</span>
                                                    <div className="row d-flex justify-content-between">
                                                        <div className="col-4">
                                                            <span className="casual-subheading">No Of Leaves</span>
                                                            <span className="casual-no">{parseFloat(props?.user?.casual_leave || 0).toFixed(1)}</span>
                                                        </div>
                                                        <div className="col-4">
                                                            <span className="casual-subheading">Total Leaves Taken</span>
                                                            <span className="casual-no">{totalCasualTakenFromBackend || 0.00}</span>
                                                        </div>
                                                    </div>
                                                </div>
                                            )
                                        }
                                    </div>
                                    <div className="col-lg-6 col-sm-12">
                                        {
                                            props.loading ? (
                                                <Skeleton className='rounded-2' width="100%" height={100} />
                                            ) : (
                                                <div className="unpaid-detail-info">
                                                    <span className="unpaid-heading">Unpaid Leave</span>
                                                    <div className="row d-flex justify-content-between">
                                                        <div className="col-4">
                                                            <span className="unpaid-subheading">No Of Leaves</span>
                                                            <span className="unpaid-no">{leaveCycleInfo?.remainingDays || 0}</span>
                                                        </div>
                                                        <div className="col-4">
                                                            <span className="unpaid-subheading">Total Leaves Taken</span>
                                                            <span className="unpaid-no">{parseFloat(props?.user?.unpaid_leave || 0).toFixed(1)}</span>
                                                        </div>

                                                    </div>
                                                </div>
                                            )
                                        }
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="row">
                <div className="col-lg-4">
                    {
                        props.loading ? (
                            <Skeleton className='rounded-2' width="100%" height={40} />
                        ) : (
                            <div className="input-group">
                                <CustomCalendar
                                    inData={inData}
                                    setFilteredData={setFilteredData}
                                    applyFilters={(params) => { applyFilters(params) }}
                                    startDate={filteredStartDate}
                                    endDate={filteredEndDate}
                                    setStartDate={setFilteredStartDate}
                                    setEndDate={setFilteredEndDate} />
                            </div>
                        )
                    }
                </div>

                <div className="col-lg-4">
                    {
                        props.loading ? (
                            <Skeleton className='rounded-2' width="100%" height={30} />
                        ) : (
                            <div className="input-group">
                                <Select
                                    options={LeaveType}
                                    styles={{
                                        ...customStyle,
                                        menu: (provided) => ({
                                            ...provided,
                                            zIndex: 2,
                                        }),
                                    }}
                                    value={clientData?.leavetype}
                                    placeholder="Leave Type"
                                    onChange={(val) => {
                                        setClientData((preVal) => ({
                                            ...preVal,
                                            leavetype: val
                                        }));
                                        applyFilters({ startDate: filteredStartDate, endDate: filteredEndDate, type: val, status: clientData?.leavestatus })
                                    }}
                                    theme={(theme) => ({
                                        ...theme,
                                        colors: {
                                            ...theme.colors,
                                            primary25: "#5757fe",
                                            primary: "#5757fe",
                                        },
                                    })}
                                />
                            </div>
                        )
                    }
                </div>

                <div className="col-lg-3">
                    {
                        props.loading ? (
                            <Skeleton className='rounded-2' width="100%" height={30} />
                        ) : (
                            <div className="input-group">
                                <Select
                                    options={LeaveStatus}
                                    styles={{
                                        ...customStyle,
                                        menu: (provided) => ({
                                            ...provided,
                                            zIndex: 2,
                                        }),
                                    }}
                                    value={clientData.leavestatus}
                                    placeholder="Leave Status"
                                    onChange={(val) => {
                                        setClientData((preVal) => ({
                                            ...preVal,
                                            leavestatus: val
                                        }));
                                        applyFilters({ startDate: filteredStartDate, endDate: filteredEndDate, type: clientData?.leavetype, status: val })
                                    }}
                                    theme={(theme) => ({
                                        ...theme,
                                        colors: {
                                            ...theme.colors,
                                            primary25: "#5757fe",
                                            primary: "#5757fe",
                                        },
                                    })}
                                />
                            </div>
                        )
                    }
                </div>

                <div className="col-lg-1">
                    {
                        shouldShowClearButton() && (
                            props.loading ? (
                                <Skeleton className='badge rounded-pill' width="100%" height={30} />
                            ) : (
                                <button
                                    className="export-btn"
                                    disabled={props.loading}
                                    onClick={handleClear}
                                >
                                    Clear
                                </button>
                            )
                        )
                    }
                </div>
            </div>

            <div className='addempleave-export-btn'>
                {
                    props.loading ? (
                        <Skeleton className="rounded-2" width={40} height={40} />
                    ) : (
                        <div className="navigation_btn">
                            <button
                                className={`btn1 ${activeButton === "empleave" ? "active" : ""}`}
                                onClick={() => handleClickBtn("empleave", "/leave/empleave")}
                            >
                                <EventsListsList
                                    color={activeButton ? "white" : "black"}
                                    bgColor={activeButton ? "black" : "white"}
                                />
                            </button>
                            <button
                                className={`btn1 ${activeButton === "empcalendar" ? "active" : ""}`}
                                onClick={() => handleClickBtn("empcalendar", "/leave/empleave/empcalendar")}
                            >
                                <EventsListsCalendar
                                    color={!activeButton ? "white" : "black"}
                                    bgColor={!activeButton ? "black" : "white"}
                                />
                            </button>
                        </div>
                    )
                }
            </div>

            <div className="invoice-table-part">
                {
                    props.loading ? (
                        <Skeleton count={5} width="100%" height={30} />
                    ) : (
                        <Table
                            header={header}
                            data={(clientData?.leavestatus || clientData?.leavetype || dateStatus) ? filteredData : inData}
                            footer={footer}
                            count={count}
                            checked={checked}
                            records={count}
                            defaultParams={params}
                            handleChange={handleChange}
                            showIsView={canView}
                            updateLeave={props?.updateLeave}
                            deleteRecord={props?.deleteRecord}
                        />
                    )
                }
            </div>
        </div>
    );
};

const mapStateToProps = (state) => {
    return {
        loading: state?.leaveReducer?.loading,
        leave: state?.leaveReducer?.leave,
        modules: state.authenticationReducer.modules,
        features: state.authenticationReducer.features,
        user: state.authenticationReducer.user,
        users: state.userReducer.users,
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        getLeaves: () => {
            dispatch(getLeaves())
        },
        updateLeave: (id, data) => {
            dispatch(updateLeave(id, data))
        },
        addMonthlyLeave: (data, navigate) => {
            dispatch(addMonthlyLeave(data, navigate));
        },
        deleteRecord: async (id, inputValue) => {
            await dispatch(deleteRecord(id, inputValue))
            await dispatch(getLeaves())
        },
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Project);